import { createContext } from 'react';
import SignInCredentials from '../models/sign-in-credentials';
import User from '../models/user';

interface IAuthContext {
  user?: User;
  isAuthenticated: boolean;
  signIn: (signInCredentials: SignInCredentials) => Promise<void>;
  refreshToken: () => Promise<boolean>;
  signOut: () => void;
}

const AuthContext = createContext({} as IAuthContext);

export default AuthContext;
